var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPFizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1505.9 621.4",
    style: {
      enableBackground: "new 0 0 1505.9 621.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0095FF;}\n\t.st1{fill:#0000C9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.2,336.3c0.7-2,1.4-3.9,2.4-5.8c23.6-47.7,124.5-67.4,269.1-49.9l29.1-107C158,154.7,49.4,176,31.3,243.7 L6.2,336.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M549.2,224.9c-0.6,1.6-1.2,3.2-1.9,4.8c-22.6,48.4-123.9,68.4-269.6,50.8l-29.1,107 c148.8,18.9,257.4-2.4,275.5-70.1L549.2,224.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.4,112.1C321,127.9,545.3,236.5,524.1,317.6l19.7-72.4c6.3-22.8,9.4-34.6,9.4-44.1 c0-82.6-216.5-183.4-422.7-196L101.4,112.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454,449C234.4,433.3,10.1,324.7,31.4,243.6L11.7,316c-6.3,22.8-9.4,34.6-9.4,44.1 c0,82.6,216.5,183.4,422.7,196L454,449z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1255,423.8c-27.8,0.4-42.6-17.3-42.6-48.7c0-2.1,0.1-4.1,0.2-6.1h109.2c2.2-8.3,3.6-17.3,3.6-25.6 c0-38.3-23.5-67.5-71.5-67.5c-49.1,0-92.7,48.4-92.7,99.2c0,48.7,31.8,78.3,84.8,78.3c23.5,0,46.6-7.9,62.8-20.2l-10.1-25.3 C1286.1,417.7,1270.6,423.5,1255,423.8L1255,423.8z M1254.7,303.3c16.2,0,24.5,10.5,24.5,33.6c0,2.2-0.1,4.5-0.4,6.9h-62.3 C1223.3,319.4,1237.8,303.3,1254.7,303.3L1254.7,303.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M822.7,265.1c0-39.7-31-68.6-78-68.6h-90.9l-68.6,252.6h57.4l25.3-93.1h49.8 C774.7,356,822.7,319.2,822.7,265.1z M695.7,326.4H676l27.2-100.3h20.7c26.1,0,40.8,17.7,40.8,41.1 C764.6,304.7,735.2,326.4,695.7,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M897.5,280.6l6.4-23.5c3.2-12.3,8.7-33.2,16.2-57.4c7.9-24.9,22.4-40.4,41.9-40.4c9.4,0,15.2,4.3,15.2,11.5 c-0.4,7.9-6.9,12.6-6.9,25.3c0,14.8,12.6,26.3,28.9,26.3c20.2,0,36.4-16.2,36.4-36.1c0-30.7-26.3-50.9-66.4-50.9 c-58.8,0-97.4,37.5-121.6,125.2l-98.2,356.9H805l84.8-309.3h57.8l-38,140.7h55.6l45.5-168.5H897.5V280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1178.9,280.6h-147.2l-7.3,27.8h71.3L985.1,449.1H1141l7.2-27.8H1068L1178.9,280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1470.5,277.7c-19.9,0-41.1,12.9-57.7,39.6l9.7-36.7h-55.6l-45.5,168.5h55.6l20.6-75.8 c8.3-31,28.5-61.3,41.9-61.3c14.4,0,9,27.1,33.9,27.1c18,0,28.9-16.6,28.9-31.8C1502.2,289.6,1488.2,277.7,1470.5,277.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPFizer);
export default __webpack_public_path__ + "static/media/pFizer.5fe2d738d2e41a7ed2b2c86044d01727.svg";
export { ForwardRef as ReactComponent };